/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductDetails,
    GetAllGroups,
    GetProductCategoties,
    GetFactoriesByGroupID,
    GetProductsByFactoryIDProductcatogeryID,
    GetCropWiseTransaction,

    GetVCCFactoriesByGroupID
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

//For only VCC type factories
async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + factoryID + '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetCropWiseTransaction(model) {
    const response = await CommonPost('/api/FarmerCropWiseTransaction/GetCropWiseTransaction', null, model);
    return response.data;
}
